import React, { useEffect, useState } from "react";
import AdminProfileDetails from "./AdminProfileDetails";
import TabComp from "./TabComp";
import { useDispatch, useSelector } from "react-redux";
import { fetchAdminData } from "../actions/adminActions";
import LoadingComp from "./LoadingComp";

const tabList = {
  "Profile Details": AdminProfileDetails,
};

const AdminProfileComp = () => {
  const [activeTab, setActiveTab] = useState(Object.keys(tabList)[0]);
  const ActiveComponent = tabList[activeTab];

  const dispatch = useDispatch();
  const { loading, isLoaded, admin, error } = useSelector(
    (state) => state.admin
  );

  useEffect(() => {
    if (!isLoaded) dispatch(fetchAdminData());
  }, [dispatch, isLoaded]);

  if (loading) {
    return <LoadingComp />;
  }

  if (error) {
    return <div>Error : {error}</div>;
  }

  return (
    <div className="mx-auto w-full ">
      <div className="flex flex-col items-start transition-all duration-500 ease-in-out transform scale-100">
        <TabComp
          tabList={tabList}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>

      {admin && (
        <div className="flex w-full flex-col items-start transition-all duration-500 ease-in-out transform scale-100">
          <ActiveComponent admin={admin} />
        </div>
      )}
    </div>
  );
};

export default AdminProfileComp;
